<template lang="pug">
.container-fluid
	.card
		.card-header.bg-info.text-white Opciones de filtrado
		.card-body
			.row
				.col-xs-12.col-sm-12.col-md-6.col-lg-8.col-xl-8
					h6 Filtro temporal
					.row
						.col
							select.form-control(v-model="filtro.tipoFecha", @change="resultados = null")
								option(value="intervalo") Intérvalo de fechas
								option(value="anos") Comparativa años
						.col
							datepicker(
								:format="(filtro.tipoFecha === 'intervalo') ? 'MMMM, yyyy' : 'yyyy'"
								placeholder="Fecha inicio"
								v-model="filtro.fecha_ini"
								:monday-first="true"
								:language='$dateLang'
								input-class="form-control"
								:minimum-view="(filtro.tipoFecha === 'intervalo') ? 'month' : 'year'"
							)
						.col
							datepicker(
								:format="(filtro.tipoFecha === 'intervalo') ? 'MMMM, yyyy' : 'yyyy'"
								placeholder="Fecha inicio"
								v-model="filtro.fecha_fin"
								:monday-first="true"
								:language='$dateLang'
								input-class="form-control"
								:minimum-view="(filtro.tipoFecha === 'intervalo') ? 'month' : 'year'"
							)
					br
					.row
						.col
							div(v-if="permisos.facturacion_consultar_todos")
								h6 Añadir clientes por agente
								input-query(
									placeholder="Busca un agente"
									class="form-control form-control-sm p-0"
									input-class="form-control form-control-sm m-0"
									:realtime="true"
									url="consultas-facturacion/php/api/porClientes/query-agentes.php"
									@selected="porAjente($event)"
								)
							.input-group(v-if="!permisos.facturacion_consultar_todos && !filtro.clientesAgente")
								.input-group-btn
									button.btn.btn-primary(@click="toggleMisClientes()")
										span.fa.fa-plus
								input.form-control(type="text" disabled="true" value="Añadir todos mis clientes")

							div.mt-2.alert.alert-info(v-if="filtro.clientesAgente !== null")
								span.fa.fa-info.mr-2
								| La consulta se limitará los clientes de <b>{{filtro.clientesAgente.nombre}} {{filtro.clientesAgente.apellidos}}</b>
								button.btn.btn-sm.btn-danger.ml-3(@click="filtro.clientesAgente = null")
									span.fa.fa-trash
						.col
							h6 Añadir clientes uno a uno
							input-query.form-control.form-control-sm.p-0(
								placeholder="Busca el cliente"
								input-class="form-control form-control-sm m-0"
								:realtime="true"
								url="consultas-facturacion/php/api/porClientes/query-clientes.php"
								@selected="ponCliente($event)"
							)
					.table-responsive(v-if="filtro.clientes.length > 0")
						table.m-0.mt-2.table.table-condensed.table-striped(style="border: 1px solid #e0e0e0;")
							thead.bg-warning
								tr
									th(colspan="2") {{filtro.clientes.length}} clientes seleccionados
							tbody
								tr(v-for="cliente in filtro.clientes" :key="cliente.ID")
									td.p-1 {{cliente.cliente}}
									td.p-1.text-right
										button.btn.btn-sm.btn-danger(@click="quitaCliente(cliente.ID)")
											span.fa.fa-trash
					div.input-group.mt-2(style="max-width:300px;")
						div.input-group-prepend
							button.btn(:class="(filtro.soloPositivos) ? 'btn-primary' : 'btn-default'" @click="filtro.soloPositivos = !filtro.soloPositivos")
								span.fa.fa-check
						input.form-control(type="text" disabled="true" value="Solo clientes con facturación")
				div.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-4
					h6 Soportes
					div
						button.m-1.btn.btn-sm(
							:class="(filtro.soportes.indexOf(soporte.ID_soporte) >= 0) ? 'btn-primary' : ''"
							v-for="soporte in listadoSoportes"
							:key="soporte.ID_soporte"
							@click="toggleSoporte(soporte.ID_soporte)"
						) {{soporte.soporte}}
					hr
					.row
						.col
							h6 Partidas
							div
								button.m-1.btn.btn-sm(
									:class="(filtro.partidas.indexOf(partida.ID_partida) >= 0) ? 'btn-primary' : ''"
									v-for="partida in listadoPartidas"
									:key="partida.ID_partida"
									@click="togglePartida(partida.ID_partida)"
								) {{partida.titulo}}
						.col
							h6 Eventos
							div
								button.m-1.btn.btn-sm(:class="(filtro.verEventos) ? 'btn-primary' : ''" @click="filtro.verEventos = !filtro.verEventos")
									| Ver eventos
					hr
					h6 Campos
					div
						button(:class="(filtro.campos.indexOf(campo.ID) >= 0) ? 'btn-primary' : 'btn-default'"
						class="btn btn-sm m-1"
						v-for="campo in listadoCampos"
						:key="campo.ID"
						@click="toggleCampo(campo.ID)"
					) {{campo.nombre}}
		div.card-footer
			button.btn.btn-sm.btn-primary(@click="consultar()")
				span.fa.fa-search.mr-1
				| Consultar

	TablaIntervalo(:resultados="resultados", v-if="filtro.tipoFecha === 'intervalo'")
	TablaComparativa(:resultados="resultados", v-if="filtro.tipoFecha === 'anos'")

	.text-center.mt-2(v-if="resultados === false")
		.card
			.card-header.bg-danger.text-white Sin resultados
			.card-body
				h1
					span.fa.fa-exclamation-triangle
				h4
					| Tu búsqueda no ha obtenido resultados
	detalles-meses(
		v-if="detalles"
		:meses="detalles.meses"
		:cliente="detalles.cliente"
		:tipo="detalles.tipo"
		@cerrar="detalles = null"
	)
</template>

<script>
import API from './api.js'
import VerDetalles from './verDetalles'
import TablaIntervalo from './tablaIntervalo'
import TablaComparativa from './tablaComparativa'
import { mapGetters } from 'vuex'

export default {
	components: {
		'detalles-meses': VerDetalles,
		'TablaIntervalo': TablaIntervalo,
		'TablaComparativa': TablaComparativa
	},
	data () {
		return {
			filtro: {
				tipoFecha: 'intervalo',
				clientes: [],
				tipoCliente: null,
				clientesAgente: null,
				soportes: [],
				campos: [],
				verEventos: true,
				partidas: [],
				fecha_ini: new Date(new Date().getFullYear(), 0, 1),
				fecha_fin: new Date(new Date().getFullYear(), 11, 1),
				soloPositivos: true
			},
			orden: {
				tipo: 'nombre',
				campo: 'nombre',
				sentido: 1
			},
			listadoSoportes: [],
			listadoPartidas: [],
			listadoCampos: [],
			resultados: null,
			detalles: null
		}
	},

	created () {
		this.$store.watch(
			a => a.session.bloqueado,
			(nuevo, viejo) => {
				if (nuevo === false) {
					this.getFormulario()
				}
			}
		)

		this.getFormulario()
	},

	computed: {
		...mapGetters({
			permisos: 'permisos/permisos',
			usuario: 'session/usuario'
		}),
		resultadosClientes () {
			if (!this.resultados) {
				return []
			}
			if (this.orden.campo) {
				return [].concat(this.resultados.clientes).sort((a, b) => {
					if (this.orden.tipo === 'campo') {
						if (a.campos[this.orden.campo].importe > b.campos[this.orden.campo].importe) {
							return this.orden.sentido
						} else if (a.campos[this.orden.campo].importe < b.campos[this.orden.campo].importe) {
							return this.orden.sentido * -1
						} else {
							return 0
						}
					} else if (this.orden.tipo === 'soporte') {
						if (a.soportes[this.orden.campo].total.real > b.soportes[this.orden.campo].total.real) {
							return this.orden.sentido
						} else if (a.soportes[this.orden.campo].total.real < b.soportes[this.orden.campo].total.real) {
							return this.orden.sentido * -1
						} else {
							return 0
						}
					} else if (this.orden.tipo === 'eventos') {
						if (a.eventos.importe > b.eventos.importe) {
							return this.orden.sentido
						} else if (a.eventos.importe < b.eventos.importe) {
							return this.orden.sentido * -1
						} else {
							return 0
						}
					} else if (this.orden.tipo === 'nombre') {
						if (a.nombre > b.nombre) {
							return this.orden.sentido
						} else if (a.nombre < b.nombre) {
							return this.orden.sentido * -1
						} else {
							return 0
						}
					} else if (this.orden.tipo === 'partida') {
						if (a.partidas[this.orden.campo].importe > b.partidas[this.orden.campo].importe) {
							return this.orden.sentido
						} else if (a.partidas[this.orden.campo].importe < b.partidas[this.orden.campo].importe) {
							return this.orden.sentido * -1
						} else {
							return 0
						}
					}
				})
			} else {
				return this.resultados.clientes
			}
		}
	},

	methods: {
		getFormulario () {
			API.getFormulario()
				.then(res => {
					this.listadoSoportes = res.data.soportes
					this.listadoPartidas = res.data.partidas
					this.listadoCampos = res.data.campos

					this.listadoCampos.forEach(campo => {
						this.toggleCampo(campo.ID)
					})

					this.listadoSoportes.forEach(soporte => {
						this.toggleSoporte(soporte.ID_soporte)
					})

					this.listadoPartidas.forEach(partida => {
						this.togglePartida(partida.ID_partida)
					})
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		toggleMisClientes () {
			this.filtro.clientesAgente = (this.filtro.clientesAgente) ? null : this.usuario
		},
		toggleCampo (ID) {
			const i = this.filtro.campos.indexOf(ID)

			if (i >= 0) {
				this.filtro.campos.splice(i, 1)
				return
			}

			this.filtro.campos.push(ID)
		},

		toggleSoporte (ID) {
			const i = this.filtro.soportes.indexOf(ID)

			if (i >= 0) {
				this.filtro.soportes.splice(i, 1)
				return
			}

			this.filtro.soportes.push(ID)
		},

		togglePartida (ID) {
			const i = this.filtro.partidas.indexOf(ID)

			if (i >= 0) {
				this.filtro.partidas.splice(i, 1)
				return
			}

			this.filtro.partidas.push(ID)
		},

		porAjente (d) {
			this.filtro.clientesAgente = d.datos
			this.filtro.tipoCliente = null
			this.filtro.clientes = []
		},

		porTipo (d) {
			this.filtro.tipoCliente = d.datos
			this.filtro.clientesAgente = null
			this.filtro.clientes = []
		},

		ponCliente (d) {
			this.filtro.tipoCliente = null
			this.filtro.clientesAgente = null

			for (let i = 0; i < this.filtro.clientes.length; i++) {
				if (this.filtro.clientes[i].ID === d.datos.ID) {
					return
				}
			}

			this.filtro.clientes.push(d.datos)
		},

		quitaCliente (ID) {
			for (let i = 0; i < this.filtro.clientes.length; i++) {
				if (this.filtro.clientes[i].ID === ID) {
					this.filtro.clientes.splice(i, 1)
					return
				}
			}
		},

		consultar () {
			API.consultar(this.filtro)
				.then(res => {
					if (!res.data.resultados.clientes || res.data.resultados.clientes.length === 0) {
						this.resultados = false
						return
					}
					this.resultados = res.data.resultados
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		}
	}
}
</script>

<style scoped>

th {
	white-space: nowrap;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/modulos/consultas-facturacion/vue/components/porClientes/main.vue